import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useFetchPatient } from '@avanta/shared/hooks/useFetchPatient';
import { isUpcomingAppointment } from '@avanta/shared/utils/appointments';
import { cn } from '@avanta/shared/utils/cn';
import { CalendarCog } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate, useParams } from 'react-router';
import { ROUTES } from 'constants/routes';
import { useFetchAppointmentsHistory } from 'hooks/useFetchAppointmentsHistory';

export const ScheduleAppointmentButton = (): React.ReactElement => {
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);
  const params = useParams();
  const patientId = params?.id ?? '';
  const { data: patient, isLoading: isLoadingPatient } = useFetchPatient(patientId);
  const { data: appointments = [], isLoading: isLoadingAppointments } =
    useFetchAppointmentsHistory(patientId);
  const upComingAppointment = appointments.find(appointment => isUpcomingAppointment(appointment));

  const handleOnClick = (): void => {
    if (upComingAppointment) {
      navigate(generatePath(ROUTES.PATIENT_APPOINTMENT, { id: patientId }), {
        state: {
          appointment: upComingAppointment,
          patient,
          from: ROUTES.PATIENT_PROFILE,
        },
      });
      return;
    }
    navigate(ROUTES.APPOINTMENTS_RESERVE, {
      state: {
        patient,
      },
    });
  };

  return (
    <Button
      variant={upComingAppointment ? 'terciary' : 'primary'}
      size="lg"
      className={cn('-mt-2', upComingAppointment ? 'w-fit' : 'w-54')}
      onClick={handleOnClick}
      isLoading={isLoadingPatient || isLoadingAppointments}
      icon={upComingAppointment ? 'leading' : undefined}
    >
      {upComingAppointment ? <CalendarCog className="size-6" /> : null}
      {upComingAppointment
        ? t('InsuredPersonsProfile.manageAppointment.cta')
        : t('InsuredPersonsProfile.scheduleAppointment.cta')}
    </Button>
  );
};
